angular.
module("dx.webapp.api").
factory("dxApiV1Jobs", function apiV1JobsService(
	$http
) {
	"use strict";

	function jobsGet(jobId) {
		return $http.get("/api/v1/jobs/" + jobId);
	}

	function jobsList(params) {
		return $http.get("/api/v1/jobs", {
			params: params,
		});
	}

	function getMetadata(jobId, type) {
		var url = "/api/v1/jobs/" + jobId + "/metadata";

		if (type) {
			url += "?type=" + type;
		}

		return $http.get(url);
	}

	return {
		get: jobsGet,
		list: jobsList,
		metadata: {
			get: getMetadata,
		},
	};
});
